import { render, staticRenderFns } from "./chooseProduct.vue?vue&type=template&id=51309485&scoped=true"
import script from "./chooseProduct.vue?vue&type=script&lang=js"
export * from "./chooseProduct.vue?vue&type=script&lang=js"
import style0 from "./chooseProduct.vue?vue&type=style&index=0&id=51309485&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51309485",
  null
  
)

export default component.exports